import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[flTrackingSection]',
})
export class TrackingSectionDirective {
  @Input() flTrackingSection: string;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/tracking/tracking-section.directive.ts